import React from 'react';
import { SpanTag } from '../../Utils/AtomicTag';
export default function LeafNode(props) {
    var node = props.node;
    return (React.createElement(SpanTag, { atomics: node.active ? ['text-brand-600', 'w-full', 'block'] : ['w-full', 'block'] }, node.title));
}
